<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultar="ngForm">
            <div fxLayout="column" fxLayoutAlign="space-around stretch" fxFlexFill>
                <div fxLayout="row">
                    <mat-form-field fxFlex="15%">
                        <mat-label>Tipo Ação</mat-label>
                        <mat-select [(ngModel)]="acaoReuniao.situacaoTipoAcao" name="tiposAcoes_{{pinTiposAcoes}}">
                            <mat-option></mat-option>        
                            <mat-option *ngFor="let m of tiposAcoes" [value]="m.flag">
                            {{m.tipo}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                   
                <div fxLayout="row">        
                    <mat-form-field fxFlex="100%" appearance="outline">
                        <mat-label>Descrição</mat-label>
                        <textarea matInput #message name="descricaoAcao" 
                                [(ngModel)]="acaoReuniao.descricaoAcao" 
                                cdkTextareaAutosize
                                #autosize="cdkTextareaAutosize" 
                                cdkAutosizeMinRows="2"
                                maxlength="900" required>
                        </textarea>
                    </mat-form-field>                
                </div>

                <div fxLayout="row">
                    <div ngModelGroup="comboParticipacao" fxFlex="100%">
                        <combo-edicao-participante-reuniao [showDisplayId]="false"
                                        [obrigatorio]="true"
                                        [selecionado]="participanteReuniao"
                                        [label]="'Responsável'"
                                        [campoPesquisavel]="'nome'"
                                        (valorChange)="onChangeNomeResponsavelAcaoReuniao($event)"
                                        >
                        </combo-edicao-participante-reuniao>
                    </div>
                    <mat-form-field fxFlexOffset="10px" fxFlex="10%">
                        <mat-label>Prazo da Reunião</mat-label>
                        <input matInput name="dataPrazo" [matDatepicker]="dataPrazo" placeholder="Prazo:"
                        (input)="onMascaraDataInput($event)" [(ngModel)]="acaoReuniao.dataPrazo">
                        <mat-datepicker-toggle matSuffix [for]="dataPrazo"></mat-datepicker-toggle>
                        <mat-datepicker #dataPrazo></mat-datepicker>
                    </mat-form-field>              
                </div>

            </div>
        </form>
    </div>
</div>

<div dir="rtl" fxLayout="row" fxLayoutAlign="center center"
     fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
     fxFlexFill>

        <button *ngIf="!isAtualizar" mat-raised-button name="botaoAdicionar" fxFlex="20%" color="primary" [disabled]=formConsultar.invalid
            (click)="adicionar()">
            Adicionar
        </button>

        <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="cancelar()">
            Cancelar
        </button>

        <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" fxFlex="20%" color="primary"
            [disabled]=formConsultar.invalid (click)="atualizar()">
            Atualizar
        </button>

</div>
